// extracted by mini-css-extract-plugin
export var inlineCard = "styles-module__inlineCard___gZOnv";
export var cardHeading = "styles-module__cardHeading___HEc4K";
export var associatedWithTrail = "styles-module__associatedWithTrail___xT42F";
export var captionOnly = "styles-module__captionOnly___aJgo4";
export var linksContainer = "styles-module__linksContainer___SDUPx";
export var hideContainer = "styles-module__hideContainer___iog1S";
export var link = "styles-module__link___rUAyS";
export var divider = "styles-module__divider___SFMpA";